import { Box, IconButton, Typography, useTheme } from '@material-ui/core'
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined'
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined'

import { getTranslate } from '../../../localization'
import { Entity } from '../../../types/auditLogs'
import useStyles from './styles/index.styles'

interface EntityTableEachRowProps {
  entity: Entity
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
  level: number
}

const EntityTableEachRow: React.FC<EntityTableEachRowProps> = ({
  entity,
  isExpanded,
  setIsExpanded,
  level
}) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Box
      className={classes.entitiesTableContainer}
      ml={level * 2}
      pl={level * 2}
      borderLeft={level !== 0 && `1px solid ${theme.palette.grey[700]}`}>
      <div>
        <Typography variant="body1">
          {getTranslate(entity.entityType)}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{entity.entityName}</Typography>
      </div>
      {/* <div>
        <Typography variant="body1">{entity.entityID}</Typography>
      </div> */}
      <div>
        <Typography variant="body1">{entity.displayEntityCode}</Typography>
      </div>
      {entity.subEntities && entity.subEntities.length > 0 && (
        <IconButton onClick={() => setIsExpanded(!isExpanded)}>
          {!isExpanded ? (
            <ExpandMoreOutlinedIcon />
          ) : (
            <ExpandLessOutlinedIcon />
          )}
        </IconButton>
      )}
    </Box>
  )
}

export default EntityTableEachRow
